import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      YOUR_MEALBOX: "Din matkasse",
      DESIGNED_BY_YOU: "Designet av deg, for deg.",
      FOOD_FOR_N_PEOPLE_N_MEALS: (portions: string, meals: string) =>
        `Mat for ${portions} personer, ${meals} middager/uke`,
      CHANGE_YOUR_PREFERENCES: "Endre dine preferanser",
      SELECT_YOUR_PREFERENCES: "Velg dine preferanser",
    },
    se: {
      YOUR_MEALBOX: "Din matkasse",
      DESIGNED_BY_YOU: "Designad av dig, för dig.",
      FOOD_FOR_N_PEOPLE_N_MEALS: (portions: string, meals: string) =>
        `Mat för ${portions} personer, ${meals} middagar/vecka`,
      CHANGE_YOUR_PREFERENCES: "Ändra dina preferenser",
      SELECT_YOUR_PREFERENCES: "Välj dina preferenser",
    },
    dk: {
      YOUR_MEALBOX: "Din måltidskasse",
      DESIGNED_BY_YOU: "Designet af dig, til dig.",
      FOOD_FOR_N_PEOPLE_N_MEALS: (portions: string, meals: string) =>
        `${portions} personer for ${meals} retter per uge`,
      CHANGE_YOUR_PREFERENCES: "Ændr din måltidskasse",
      SELECT_YOUR_PREFERENCES: "Vælg dine præferencer",
    },
  } as const
)[language];
